<div class="component-modal-header">
  <span class="modal-title">{{ title }}</span>
  <button type="button" class="close" aria-label="Close" (click)="closeModal()">
    <span class="pi pi-times"></span>
  </button>
</div>
<div class="modal-body session-photo-modal-body">
  <ng-container *ngFor="let response of siteFormResponses">
    <div class="card">
      <div class="card-body">
        <p class="photoCaption">{{ response.form.name }}&nbsp;&nbsp;<a class="under-row" href="javascript:void(0)" (click)="viewResponse(response)">view</a></p>
        <p class="createdDetails">
          {{ response.user?.fullName }} - {{ response.createdDate | date: 'E d MMM yyyy HH:mm' }}
        </p>
      </div>
    </div>
  </ng-container>
  <div *ngIf="selectedResponse">

    <br>
    <div *ngIf="selectedResponse.attachments.length">
      <h6>Attached Documents</h6>
      <div *ngFor="let file of selectedResponse.attachments" class="file-list-item">
        <p>
          {{ file | fileName }}
        </p>
        <div class="file-list-links">
          <button type="button" class="btn btn-primary btn-link" (click)="openAttachment(file)">view</button>
        </div>
      </div>
    </div>
    <div class="form-group form-group-checkbox mt-0">
      <label>Include photos?</label>
      <p-checkbox class="form-control" [(ngModel)]="includePhotos" binary="true"></p-checkbox>
    </div>
    <div class="d-flex justify-content-end mb-3">
      <button [disabled]="isLoading || downloadClicked" class="btn btn-primary" (click)="downloadPDF()">Download PDF</button>
    </div>
    <div class="row animated fadeIn">
      <div class="col-md-12">
        <div class="pdf-export-wrapper">
          <site-form-response-preview-pane *ngIf="!isLoading" [logoUrl]="logoUrl" [siteFormResponse]="selectedResponse" [includePhotos]="includePhotos"></site-form-response-preview-pane>
        </div>
      </div>
      <br>
    </div>
  </div>
  <br>
</div>
